export default __webpack_public_path__ + "navigation-examples-custom-banner-thumbnail-480-0de5158e3dd88b669737abe303488408.webp";